/* eslint-disable max-len */
// import axios from 'axios'
import React, { useState } from 'react';
import { Text, Pane, Flex, Button, PortalOverlay, Toast, Radio } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import classes from './EnableDataSharingClasses.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function EnableDataSharingView(props) {
  const {
    onClose,
    parentIncomingTransfer,
    reloadData,
    locationId
  } = props;
  const parentIncomingTransferId = parentIncomingTransfer.id;
  const systemId = parentIncomingTransfer.systemId;
  const transferredDevicesAlias = parentIncomingTransfer.data?.transferredDevicesAlias;
  const numItems = parentIncomingTransfer.data?.numItems;
  const [dataSharingSetting, setDataSharingSetting] = useState();
  const [loading, setLoading] = useState();
  const submitDisabled = dataSharingSetting == null || loading;
  const onSubmit = () => {
    try {
      setLoading(true);
      GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => {
        try {
          const res = await api.system(systemId).device(parentIncomingTransferId).srv('ownershipTransfer').post('acceptBulkTransfer', {
            newLocationId: locationId,
            dataSharingOn: dataSharingSetting === 'on',
            deviceAlias: transferredDevicesAlias
          });
          if (res.status !== 500) {
            setTimeout(async () => {
              await reloadData();
            }, 2000);
            Toast.success('Transfer accepted');
          } else {
            Toast.error('Error in accepting Transfer');
          }
        } catch (error) {
          Toast.error('Error in accepting Transfer');
        }
      });
    } catch (error) {
      Toast.error('Error in accepting Transfer');
    } finally {
      onClose();
    }
  };
  const iconBackgroundStyle = {
    height: '24px',
    width: '24px',
    borderRadius: '2px',
    backgroundColor: '#F0F6FF',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  const iconStyle = {
    color: '#1646C5',
    position: 'absolute',
    align: 'center'
  };
  const renderDialog = () => {
    return /*#__PURE__*/_jsxs(Pane, {
      variant: "editorDialog",
      className: classes.dialog,
      children: [/*#__PURE__*/_jsxs(Flex, {
        className: classes.dialogHeader,
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          style: {
            fontWeight: 'bold'
          },
          icon: /*#__PURE__*/_jsx(Flex, {
            style: {
              ...iconBackgroundStyle
            },
            children: /*#__PURE__*/_jsx("i", {
              style: {
                ...iconStyle
              },
              className: "fa-kit fa-lv-transfer-building"
            })
          }),
          children: "Accept Transfer"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "closeWindow",
          icon: "fa fa-remove",
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(Pane, {
        className: classes.dialogBody,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "col",
          justify: "space-between",
          columnGap: 16,
          children: [/*#__PURE__*/_jsxs(Text, {
            variant: "bodySmall",
            style: {
              fontSize: '16px'
            },
            children: ["Would you like to enable data sharing for ", /*#__PURE__*/_jsxs("b", {
              children: [numItems, " Transferred Items"]
            }), " to grant all users at its previous location view-only access to its details and location? Data sharing can be disabled at any time."]
          }), /*#__PURE__*/_jsx(Text, {
            style: {
              fontWeight: 'bold',
              paddingTop: '16px'
            },
            children: "Enable Data Sharing"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              paddingTop: '16px'
            },
            children: /*#__PURE__*/_jsx(Radio, {
              className: classes.radioButton,
              label: "Yes, enable data sharing",
              labelVariant: "inputCaption",
              on: "on",
              value: dataSharingSetting,
              onChange: data => {
                setDataSharingSetting('on');
              }
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              paddingTop: '16px'
            },
            children: /*#__PURE__*/_jsx(Radio, {
              className: classes.radioButton,
              label: "No, keep data sharing disabled",
              labelVariant: "inputCaption",
              on: "off",
              value: dataSharingSetting,
              onChange: data => {
                setDataSharingSetting('off');
              }
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        className: classes.dialogFooter,
        justify: "flex-end",
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          className: classes.button,
          onClick: onClose,
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "submit",
          disabled: submitDisabled,
          onClick: onSubmit,
          children: " Accept Transfer "
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: true,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: renderDialog()
  });
}